module.exports = __webpack_public_path__ + "static/media/ten-ball.62310473.png";